import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display:flex;
    flex-direction: column;
    gap: 10px;
`;

const StyledButton = styled(CustomBlockButton)`
    border: none;
    border-radius: 3px;
    color: #fff;
    font-weight: 600;
    &.preparing {
    background-color: #d0d0d0;
    }
    &.collection-request {
    background-color: #ff9f40; 
    }
    &.collecting {
    background-color: #f76707;
    }
    &.collection-complete {
    background-color: #51cf66;
    }
    &.inspection-complete {
    background-color: #1c7ed6;
    }
    &.processing-complete {
    background-color: #7048e8;
    }
    &.return-shipment {
    background-color: #fa5252;
    }
    &.exchange-re-shipment-preparation {
    background-color: #ffd43b;
    }
    &.exchange-re-shipment-complete {
    background-color: #008c8c;
    }
`;

export function SelectStatusModal({
    open,
    onClose,
    onChangeStatus
}) {
    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            진행상태 변경
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <StyledButton
                        type='button'
                        className='preparing'
                        onClick={() => onChangeStatus('PREPARING')}
                    >
                        준비중
                    </StyledButton>
                    <StyledButton
                        type='button'
                        className='collection-request'
                        onClick={() => onChangeStatus('COLLECTION_REQUEST')}
                    >
                        수거요청
                    </StyledButton>
                    <StyledButton
                        type='button'
                        className='collecting'
                        onClick={() => onChangeStatus('COLLECTING')}
                    >
                        수거중
                    </StyledButton>
                    <StyledButton
                        type='button'
                        className='collection-complete'
                        onClick={() => onChangeStatus('COLLECTION_COMPLETE')}
                    >
                        수거완료
                    </StyledButton>
                    <StyledButton
                        type='button'
                        className='inspection-complete'
                        onClick={() => onChangeStatus('INSPECTION_COMPLETE')}
                    >
                        검수완료
                    </StyledButton>
                    <StyledButton
                        type='button'
                        className='processing-complete'
                        onClick={() => onChangeStatus('PROCESSING_COMPLETE')}
                    >
                        처리완료
                    </StyledButton>
                    <StyledButton
                        type='button'
                        className='return-shipment'
                        onClick={() => onChangeStatus('RETURN_SHIPMENT')}
                    >
                        반송
                    </StyledButton>
                    <StyledButton
                        type='button'
                        className='exchange-re-shipment-preparation'
                        onClick={() => onChangeStatus('EXCHANGE_RE_SHIPMENT_PREPARATION')}
                    >
                        교환재출고준비
                    </StyledButton>
                    <StyledButton
                        type='button'
                        className='exchange-re-shipment-complete'
                        onClick={() => onChangeStatus('EXCHANGE_RE_SHIPMENT_COMPLETE')}
                    >
                        교환재출고완료
                    </StyledButton>
                </StyledBody>
            </CustomDialog>
        </>
    );
}